var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dyn-textarea" }, [
    _c("div", { domProps: { innerHTML: _vm._s(_vm.htmlValue) } }),
    _vm._v(" "),
    _c("textarea", {
      attrs: { placeholder: _vm.placeholder },
      domProps: { value: _vm.value },
      on: {
        input: function($event) {
          return _vm.$emit("input", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }